export enum FeatureIds {
  USER_PANEL_SIGNUP = "mobility-item-page-user-panel-signup-release",
  DEALER_INFO_CARD_HOMEPAGE_SURVEY = "mobility-item-page-dealer-info-card-homepage-survey-release",
  ENABLE_CAR_RESERVATION_CTA = "mobility-item-page-car-reservation-cta-release",
  ENABLE_INLINE_FEEDBACK_FORM = "mobility-item-page-inline-feedback-form-release",
  ENABLE_EXPERT_CAR_REVIEW = "mobility-item-page-expert-car-review-release",
  ENABLE_EV_INFO_SECTION = "mobility-item-page-ev-info-section-release",
}

export type FeatureToggles = Record<FeatureIds, boolean>;
